export default [
  {
    key: 'topic',
    label: 'field.topic',
    type: 'text',
    md: 10,
    lg: 10,
  },
  {
    key: "period",
    label: "field.date",
    type: "radio",
    options: [
      { text: "field.today", value: "today" },
      { text: "field.yesterday", value: "yesterday" },
      { text: "field.thisWeek", value: "thisWeek" },
      { text: "field.lastWeek", value: "lastWeek" },
      { text: "field.thisMonth", value: "thisMonth" },
      { text: "field.lastMonth", value: "lastMonth" },
      { text: "field.other", value: "other" },
    ],
    md: 12,
    lg: 12,
    skip: true,
  },
  // {
  //   lg: 4,
  // },
  {
    key: "startDate",
    label: "field.fromDate",
    type: "date",
    lg: 4,
  },
  {
    key: "endDate",
    label: "field.toDate",
    type: "date",
    lg: 4,
  },
];
